import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal, Button } from 'react-bootstrap';
import { ColorRing } from 'react-loader-spinner';
import QuestionsContainer from '../../common/QuestionsContainer';
import ProfileSuggestionModal from '../../ProfileSuggestionModal';

const renderSpinner = () => (
  <ColorRing
    visible
    height="20"
    width="20"
    ariaLabel="blocks-loading"
    wrapperStyle={{}}
    wrapperClass="updating-icon me-2"
    colors={Array(5).fill('#FFFFFF')}
  />
);

class EditUser extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isHovering: false,
      showModal: false,
      confirmationSent: false,
      answers: props.answers,
      saveDisabled: false,
    };
    this.handleMouseOver = this.handleMouseOver.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);
    this.handleShowModal = this.handleShowModal.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
    this.handleAppendTags = this.handleAppendTags.bind(this);
    this.handleClearSuggestions = this.handleClearSuggestions.bind(this);
    this.handleToggleSave = this.handleToggleSave.bind(this);
  }

  handleMouseOver() {
    this.setState({ isHovering: true });
  }

  handleMouseLeave() {
    const { showModal } = this.state;
    if (!showModal) {
      this.setState({ isHovering: false });
    }
  }

  handleShowModal() {
    this.setState({ showModal: true });
  }

  handleCloseModal() {
    const { getAnswers, updateCompletionPercentage } = this.props;
    getAnswers().then((response) => {
      updateCompletionPercentage();
      this.setState({ answers: response.data, showModal: false, isHovering: false });
    });
  }

  handleAppendTags() {
    const { updateSuggestedTags, getAnswers, updateCompletionPercentage } = this.props;

    updateSuggestedTags([], 'Level');

    getAnswers().then((response) => {
      updateCompletionPercentage();
      this.setState({ answers: response.data, showModal: false, isHovering: false });
    });
  }

  handleClearSuggestions(tagIds) {
    const { updateSuggestedTags, suggestedTags } = this.props;

    updateSuggestedTags(suggestedTags.Level.filter((tag) => !(tagIds.includes(tag.id))), 'Level');
  }

  handleToggleSave(saveDisabled) {
    this.setState({ saveDisabled });
  }

  renderEdit() {
    const { editMode } = this.props;
    const { isHovering } = this.state;
    if (isHovering || editMode) {
      return (
        <a
          className="edit-attribute medium-weight body-text-2"
          tabIndex={0}
          role="button"
          onClick={() => this.handleShowModal()}
        >
          Edit
        </a>
      );
    }
    return null;
  }

  renderAdd(attribute, text) {
    return (
      <span className={`add-answer ${attribute} body-text-3 mr-16`}>
        <a
          tabIndex={0}
          role="button"
          onClick={() => this.handleShowModal()}
        >
          <i className="fa fa-plus" />
          {`Add ${text}`}
        </a>
        {attribute === 'seniorities' && this.renderSenioritySuggestions()}
      </span>
    );
  }

  renderField(attribute, icon, answer) {
    return (
      <span className={`${attribute} body-text-2 me-3`}>
        <i className={`fa ${icon} me-2`} />
        {answer}
        {attribute === 'seniorities' && this.renderSenioritySuggestions()}
      </span>
    );
  }

  renderSenioritySuggestions() {
    const { csrfToken, suggestedTags, showSuggestionModal } = this.props;

    if (!suggestedTags.Level || suggestedTags.Level.length === 0) return null;

    return (
      <ProfileSuggestionModal
        tags={suggestedTags.Level}
        csrfToken={csrfToken}
        appendTags={this.handleAppendTags}
        clearTags={this.handleClearSuggestions}
        showEdit={false}
        forceShow={showSuggestionModal === 'Level'}
      />
    );
  }

  renderAttribute(attribute, icon, answer, addText) {
    if (answer) {
      return this.renderField(attribute, icon, answer);
    }
    return this.renderAdd(attribute, addText);
  }

  renderForm() {
    const {
      questionnaireQuestions,
      questionableId,
      questionableType,
      questionnaireName,
      csrfToken,
      userId,
    } = this.props;
    return (
      <div className="work-preferences-form">
        <QuestionsContainer
          questionnaireName={questionnaireName}
          questionIds={questionnaireQuestions}
          questionableId={questionableId}
          questionableType={questionableType}
          csrfToken={csrfToken}
          handleToggleSave={this.handleToggleSave}
          userId={userId}
          owner
        />
      </div>
    );
  }

  render() {
    const { showModal, answers, saveDisabled } = this.state;
    const location = answers.find((a) => a.question_key === 'Location').answer;
    const seniorities = answers.find((a) => a.question_key === 'Role Level').answer.map((a) => a.label);
    const yearsOfExperience = answers.find((a) => a.question_key === 'Years Of Experience').answer;
    return (
      <div
        onMouseOver={this.handleMouseOver}
        onMouseLeave={this.handleMouseLeave}
      >
        <div className="level-yrs-location pt-2">
          {this.renderAttribute(
            'years-of-experience',
            'fa-id-card-alt',
            yearsOfExperience && `${yearsOfExperience} year${yearsOfExperience === 0 || yearsOfExperience > 1 ? 's' : ''} of experience`,
            'Years of Experience',
          )}
          {this.renderAttribute('seniorities', 'fa-certificate', seniorities.join(', '), 'Seniority')}
          {this.renderAttribute('location', 'fa-map-marker-alt', location, 'Location')}
          {this.renderEdit()}
        </div>
        <Modal show={showModal} onHide={this.handleCloseModal}>
          <Modal.Header closeButton className="no-border-bottom" />
          <Modal.Body className="style-guide">
            {this.renderForm()}
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="primary"
              onClick={this.handleCloseModal}
              disabled={saveDisabled}
              className={`save-button ${saveDisabled ? 'with-spinner' : ''}`}
            >
              { saveDisabled && renderSpinner() }
              Save
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

EditUser.propTypes = {
  csrfToken: PropTypes.string.isRequired,
  editMode: PropTypes.bool.isRequired,
  answers: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  getAnswers: PropTypes.func.isRequired,
  questionableId: PropTypes.number.isRequired,
  questionableType: PropTypes.string.isRequired,
  questionnaireName: PropTypes.string.isRequired,
  questionnaireQuestions: PropTypes.arrayOf(PropTypes.number).isRequired,
  updateCompletionPercentage: PropTypes.func.isRequired,
  suggestedTags: PropTypes.shape({}),
  updateSuggestedTags: PropTypes.func,
  showSuggestionModal: PropTypes.string,
  userId: PropTypes.number.isRequired,
};

EditUser.defaultProps = {
  showSuggestionModal: '',
  suggestedTags: {},
  updateSuggestedTags: () => {},
};

export default EditUser;
